import parseIntOrFloat from "@/utils/parseIntOrFloat";

export type Converter<TApi, TLegacy> = {
  apiToLegacy: (data: TApi) => TLegacy;
  legacyToApi: (data: TLegacy) => TApi;
};

export type CreateConverter<TApi, TLegacy, TCreate> = Converter<TApi, TLegacy> & {
  createToApi: (data: TCreate) => Partial<TApi>
}

export type UpdateConverter<TApi, TLegacy, TUpdate> = Converter<TApi, TLegacy> & {
  updateToApi: (data: TUpdate) => Partial<TApi>
}

export type CrudConverter<TApi, TLegacy, TCreate, TUpdate> = Converter<TApi, TLegacy> & {
  createToApi: (data: TCreate) => Partial<TApi>
  updateToApi: (data: TUpdate) => Partial<TApi>
}

export type _rudConverter<TApi, TLegacy, TUpdate> = Converter<TApi, TLegacy> & {
  updateToApi: (data: TUpdate) => Partial<TApi>
}


export const process_number_or_null = (value: unknown): number | null => {
  if (typeof value !== 'number' && typeof value !== 'string') return null

  const parsed = parseIntOrFloat(value)

  return parsed === undefined ? null : parsed
}
